import { Layout, Menu } from 'antd';
import { ReactComponentElement, useCallback, useEffect, useState } from 'react';
import styles from "./Sidebar.module.scss";
import greenwiselogo from '../../../globals/images/Layout/balanceimg1.png';
import greenwiseicon from '../../../globals/images/Layout/balance1.png';
import rosaPrimaLogo from '../../../globals/images/EF_Fincas_Logos/RosaprimaRedLogo.png';
import rosaPrimaIcon from '../../../globals/images/EF_Fincas_Logos/IconoRosaPrima.png';
import expoflores from '../../../globals/images/Layout/logoExpoFlores.png';
import expofloresicon from '../../../globals/images/Layout/loadingExpoflores.png';



import SideBarSubMenu from './SidebarSubMenu';
import Navbar from './Navbar';
import {
    LogoutOutlined
} from '@ant-design/icons';
import { logout } from '../../../services/auth';
import useMediaQuery from '../hooks/useMediaQuery';
import { connect } from 'react-redux';
import { AppState } from '../../../store';
import { Module } from '../../../store/user/types';
import { useHistory } from 'react-router-dom';
import iconMap from './iconMapping';
import { getAllModuleToken, getUserInfoByToken } from '../../../store/user/thunks';


const { Header, Content, Sider } = Layout;
interface MenuItem {
    sequential: string;
    label: string;
    link: string;
    icon?: string;
    keySubModule: string;
}
interface UserProps {
    getAllModuleToken: any;
    children: any;
}

const SideBar: React.FC<UserProps> = (props: UserProps) => {
    const history = useHistory();
    const [dataTableModule, setDataTableModule] = useState<Module[]>([]);
    const [collapsed, setCollapsed] = useState(true);

    const init = async () => {
        const responseDataRespone = await props.getAllModuleToken();
        console.log(responseDataRespone);
        setDataTableModule(responseDataRespone);
    };

    useEffect(() => {
        init();
    }, []);

    const queries = {
        md: "(max-width: 768px)",
    };
    const matches = useMediaQuery(queries.md);

    const onLogout = async () => {
        await logout();
        history.push('/');
    };

    const [isImageLogo, setImageLogo] = useState(greenwiselogo);
    const [isLogoStyle, setIsLogoStyle] = useState("");
    const [isLogOut, setIsLogOut] = useState("");
    //EF LOGO Styles
    const [isEFImageLogo, setEFImageLogo] = useState(expofloresicon);
    const [isEFLogoStyle, setEFIsLogoStyle] = useState("");
    const handleCollapse = (value: boolean) => {        
        setCollapsed(value);
        if (value) {
            setImageLogo(greenwiseicon)
            setEFImageLogo(expofloresicon)
            setIsLogOut("")
            setIsLogoStyle("")
        } else {
            setImageLogo(greenwiselogo)
            setEFImageLogo(expofloresicon)
            setIsLogOut("Cerrar sesión")
            setIsLogoStyle("-complete")
        }
    };



    return (
        <div className={styles["layout-admin-container"]}>
            <Layout>
                {!matches && (
                    <Sider collapsible collapsed={collapsed} onCollapse={handleCollapse} className={styles["layout-admin-sider"]}>

                        {process.env.REACT_APP_CODE_TENANT == "SM" ? <div className={styles["layout-admin-logo" + isLogoStyle]}>
                            <img loading="lazy" src={isImageLogo} alt="GreenLogo" />
                        </div>:process.env.REACT_APP_CODE_TENANT == "EF" && <div className={styles["layout-admin-logo"]}>
                            <img loading="lazy" src={isEFImageLogo} alt="GreenLogo" />
                        </div>}
                        
                        <Menu className={styles["layout-admin-menu"]} mode="vertical">
                            <>
                                {dataTableModule.map((singleOption: any) => {
                                    const IconComponent = iconMap[singleOption.icon];

                                    if (!IconComponent) {
                                        console.warn(`Icon "${singleOption.icon}" not found in iconMap`);
                                    }
                                    return (
                                        <>
                                            {singleOption.items.length > 0 ?

                                                <Menu.SubMenu
                                                    style={{ color: 'black', backgroundColor: '#ffffff' }}
                                                    title={
                                                        <div className={styles["layout-admin-text"]}>
                                                            {IconComponent && <IconComponent />}
                                                            <span>{singleOption.label}</span>
                                                        </div>
                                                    }
                                                >
                                                    {singleOption.items.map((child: MenuItem) => {
                                                        const ChildIconComponent = child.icon ? iconMap[child.icon] : null;

                                                        return (
                                                            <Menu.Item
                                                                key={child.keySubModule}
                                                                onClick={() => history.push(`/${child.link}`)}
                                                                style={{ color: 'black', backgroundColor: '#ffffff' }}
                                                            >
                                                                <div className={styles["layout-admin-submenu-item-text"]}>
                                                                    {ChildIconComponent && <ChildIconComponent />}
                                                                    <span>{child.label}</span>
                                                                </div>
                                                            </Menu.Item>
                                                        );
                                                    })}
                                                </Menu.SubMenu>
                                                : <Menu.Item
                                                    key={singleOption.keySubModule}
                                                    onClick={() => history.push(`/${singleOption.link}`)}
                                                    style={{ color: 'black', backgroundColor: '#ffffff' }}
                                                    title={singleOption.label} //
                                                >
                                                    <div className={styles["layout-admin-text"]}>
                                                        {IconComponent && <IconComponent />}
                                                        <span>{singleOption.label}</span>
                                                    </div>
                                                </Menu.Item>}
                                        </>

                                    );
                                })}

                            </>
                        </Menu>
                        <div onClick={onLogout} className={styles["layout-admin-header-logout" + isLogoStyle]}>
                            <LogoutOutlined /> {isLogOut}
                        </div>
                    </Sider>
                )}
                <Layout>
                    <Content className={styles["layout-admin-content"]}>
                        {props.children}
                    </Content>
                </Layout>
            </Layout>
        </div>
    );
}
const mapStateToProps = (state: AppState) => ({

});
export default connect(mapStateToProps, {
    getAllModuleToken
})(SideBar);
